import React from 'react';
import { useTranslation } from 'react-i18next';
import Money from 'src/common/entity/basic-types/Money';
import { priceFormatter } from 'src/utils/formatters';
import BigNumber from 'bignumber.js';

interface StoreModuleCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    fee: Money;
    moduleType: string;
    variableFee?: Money;
    oneTimeFee: boolean;
    oneTimeFeeAmount?: Money;
    oneTimeFeeModuleRemainsActive: boolean;
    actionComponent?: React.ReactNode;
    featured?: Boolean;
    hasMinimumFee?: Boolean;
    deactivateModuleAt?: string;
    onClick: () => void;
}

export const StoreModuleCard = ({
    icon,
    title,
    description,
    fee,
    oneTimeFee,
    actionComponent,
    deactivateModuleAt,
    onClick,
    oneTimeFeeModuleRemainsActive,
    featured,
    hasMinimumFee,
    variableFee,
    moduleType,
    oneTimeFeeAmount,
}: StoreModuleCardProps) => {
    const { t } = useTranslation();
    const isModuleFree =
        fee.amount != null && Number(fee.amount) === 0 && variableFee == null && oneTimeFeeAmount == null;

    return (
        <div className={`card ${featured ? 'featured-store-module' : ''}`} onClick={onClick}>
            <div className="module-title">
                {icon}
                <h4>{title}</h4>
            </div>

            <div>
                <p>{description}</p>
            </div>

            <div className="action-row">
                <span>
                    <table className="table table-responsive" style={{ border: 'none', textAlign: 'left' }}>
                        <tbody style={{ fontSize: '12px' }}>
                            {isModuleFree && (
                                <span className="text-success bold" style={{ fontWeight: 'bold' }}>
                                    {t('modules_store.free')}
                                </span>
                            )}
                            {(hasMinimumFee || fee.amount > new BigNumber(0)) && (
                                <tr style={{ border: 'none', padding: 2 }}>
                                    <td style={{ border: 'none', padding: 2 }}>
                                        {hasMinimumFee
                                            ? t('modules_store.min_monthly_fee')
                                            : t('modules_store.monthly_fee')}
                                    </td>
                                    <td style={{ border: 'none', padding: 2, textAlign: 'right' }}>
                                        {priceFormatter(fee)}
                                    </td>
                                </tr>
                            )}

                            {oneTimeFeeAmount && !isModuleFree && (
                                <tr style={{ border: 'none', padding: 2 }}>
                                    <td style={{ border: 'none', padding: 2 }}>
                                        {t('modules_store.one_time_fee', { fee: '' })}
                                    </td>

                                    <td style={{ border: 'none', padding: 2, textAlign: 'right' }}>
                                        {priceFormatter(oneTimeFeeAmount)}
                                    </td>
                                </tr>
                            )}
                            {variableFee && (
                                <tr>
                                    <td style={{ border: 'none', padding: 2 }}>
                                        {t('modules_store.monthly_variable_fee')}
                                    </td>
                                    <td style={{ border: 'none', padding: 2, textAlign: 'right' }}>
                                        {priceFormatter(variableFee)}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </span>

                {actionComponent}
            </div>
        </div>
    );
};
